import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import Payments from "modules/payments";
import PaymentsRayan from "modules/paymentsRayan";
import PaymentsRequest from "modules/paymentsRequest";
import { FadeInt2Div } from "styledComponents/animation";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import WithdrawOnlineHistory from "modules/paymentsRequest/withdrawal/requestHistory";
import { getlocalStorageLogin } from "common/components/apiConfig";

let useStyles = makeStyles({
  header: {
    backgroundColor: "#ffffff",
    boxShadow: "lightgrey 0px 0px 10px",
  },
  TabPanel: {
    "& > div": {
      padding: "10px 0px 10px 0px !important",
    },
    "& > div > div": {
      width: "100%",
      overflow: "auto",
    },
  },
  Tab: {
    fontWeight: "bold !important",
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Invite = () => {
  let classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const permission = (nationalIdList) => {
    const adminObj = getlocalStorageLogin();

    // const adminData = JSON?.parse(localStorage?.getItem("admin"));
    const user = adminObj?.user;
    const nationalId = user?.member_national_id;

    const havePermission = nationalIdList.includes(nationalId);
    return havePermission;
  };
  const asadi = [
    "0016094530",
    "0083402691",
    "0022893938",
    "1672374677",
    "0081741588",
    "0015761843",
    "0019192967",
    "2560071721",
    "1450965164",
  ];
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{ borderBottom: 1, borderColor: "divider" }}
          className={`${classes["header"]} py-0 px-5 rounded-lg overflow-auto`}
        >
          <Tabs
            scrollButtons="auto"
            textColor="primary"
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            className={`${classes["TabPanel"]} hiddenScroll`}
            style={{ msOverflowStyle: "none", scrollbarWidth: "none" }}
          >
            <Tab
              label=" ثبت درخواست وجه"
              {...a11yProps(0)}
              className={classes["Tab"]}
            />
            {/* <Tab
              label="درخواست های مرکز خدمات"
              {...a11yProps(1)}
              className={classes["Tab"]}
            />
            <Tab
              label="درخواست های اکسیر"
              {...a11yProps(2)}
              className={classes["Tab"]}
            /> */}
            <Tab
              label="درخواست های برداشت آنی"
              {...a11yProps(1)}
              className={classes["Tab"]}
            />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0} className={classes["TabPanel"]}>
          <FadeInt2Div>
            <PaymentsRequest />
          </FadeInt2Div>
        </TabPanel>
        {/* <TabPanel value={value} index={1} className={classes["TabPanel"]}>
          <FadeInt2Div>
            <Payments />
          </FadeInt2Div>
        </TabPanel>
        <TabPanel value={value} index={2} className={classes["TabPanel"]}>
          <FadeInt2Div>
            <PaymentsRayan />
          </FadeInt2Div>
        </TabPanel> */}
        <TabPanel value={value} index={1} className={classes["TabPanel"]}>
          <FadeInt2Div>
            <WithdrawOnlineHistory />
          </FadeInt2Div>
        </TabPanel>
      </Box>
    </>
  );
};

export default Invite;
